import { IBaseVoucher } from 'types/income';
import { BaseVoucher } from './vouchers.types';

export const convertBaseVoucher = (voucher: IBaseVoucher): BaseVoucher => {
  return {
    id: voucher.id,
    order: voucher.marketplaceOrderId
      ? {
          id: voucher.marketplaceOrderId,
          name: voucher.marketplaceOrderNr ?? '',
        }
      : null,
    status: voucher.status,
    price: voucher.price,
    purchasePrice: voucher.purchasePrice,
    purchaseReference: voucher.purchaseReference,
    currency: voucher.currency,
    sequence: voucher.sequence,
    redeem: {
      qrCode: voucher.qrCode ?? '',
      barCode: voucher.barCode ?? '',
      serial: voucher.serial ?? '',
      url: voucher.url ?? '',
      code: voucher.code ?? '',
      pin: voucher.pin ?? '',
    },
    fileLink: voucher.fileLink ?? '',
    createdAt: voucher.creationDate,
    expiresAt: voucher.expirationDate,
    lastAccess: voucher.lastAccess ?? null,
  };
};
